import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Form,
  Label,
  LabelInput,
} from '../../common/components/form';
import { StyledStaticField } from '../../common/components/form/ui';
import { Localize } from '../../../locale/localization';

const EditProfileSimple = (props) => {
  const {
    email, //readonly
  } = props;

  return (
    <Form>
      <Label label={Localize('form.user.label')} half>
        <StyledStaticField>{email}</StyledStaticField>
      </Label>
      <LabelInput
        half
        disabled
        label={Localize('password')}
        name="password"
        type="password"
        value="*****"
      >
        <NavLink to="/profile/changePassword">{Localize('password.change')}</NavLink>
      </LabelInput>
    </Form>
  );
};

export default EditProfileSimple;


// WEBPACK FOOTER //
// ./src/modules/user/components/EditProfileSimple.js